export default __webpack_public_path__ + "static/media/parks_title.d8e2dd2e.svg";